// @format

export function initLanguagePicker(): void {
  $(document).on('click', '.language-picker', e => {
    $('.language-picker-menu').toggleClass('show');
  });
}
